import { RMount } from './RMount';
import { resolveNoContainer } from './resolve-no-container';
import { resolveRendersOwnElement } from './resolve-renders-own-element';
import { defaultAttributeValues } from './default-attribute-values';
import { attributeEditModeConfigs } from './attribute-edit-mode-configs';
import type { DisplayCardEntry, WidgetInstanceProps } from '@source-components-react/types';
import { ComponentIdentifiers } from '@source-components-react/component-identifiers';
import type { MountsMap } from './mount-attributes';

export const displayCardEntry: DisplayCardEntry = {
  id: ComponentIdentifiers.rMount,
  resolveNoContainer,
  resolveRendersOwnElement,
  card: ({
    componentAttributes,
    styleProps,
    className,
    mounts,
    widgetInstanceProps,
  }: {
    componentAttributes?: { [key: string]: any };
    styleProps?: { [key: string]: any };
    className?: string;
    mounts?: MountsMap;
    widgetInstanceProps?: WidgetInstanceProps;
  }) => (
    <RMount
      componentAttributes={componentAttributes}
      styleProps={styleProps}
      className={className}
      mounts={mounts}
      widgetInstanceProps={widgetInstanceProps}
    />
  ),
  defaultAttributeValues,
  attributeEditModeConfigs,
};
